module.exports = __webpack_public_path__ + "media/images/project/calendar-152ab694ed9b2eccb68d9fdfa9a119e6.svg";